import React from 'react'
import DesktopView from '../../components/User/NewMemberSetup/DesktopView';
import MobileView from '../../components/User/NewMemberSetup/MobileView';

const NewMemberSetup = () => {
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile ? <MobileView /> : <DesktopView />
}

export default NewMemberSetup;